import { bindActionCreators } from 'redux';
import State from '@wfp-root-app/store/state';
import { connect } from 'react-redux';
import { BeneficiaryPrimaryIdentifierToShow } from '@wfp-root-app/appConfig';

import AsyncTasksPage from './AsyncTasksPage';
import { ManagerPermission } from '../../permission-profiles/permission';
import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import { hasFeatureAccess } from '../../login/auth';
import AsyncTasksListView from '../AsyncTasksListView';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        authorizeTask: bindActionCreators(AsyncActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(
                AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.UPLOAD_TAX_ID_FAMILY_TAX_ID_MAPPING)
            ),
        uploadFile: (
            data: File,
            dryRun?: boolean,
            mapping?: Record<number, string>,
            dryRunAsyncTaskId?: string,
            additionalData: Record<string, unknown> = {}
        ) => {
            const params: Record<string, unknown> = {
                data,
                mapping,
                startIndex: 2,
                schedule: !dryRun,
                ...additionalData,
            };

            if (dryRun) {
                params.dryRun = true;
            }
            if (dryRunAsyncTaskId) {
                params.dryRunAsyncTaskId = dryRunAsyncTaskId;
            }
            return dispatch(BeneficiaryActionCreators.importTaxIdFamilyTaxIdMapping(params));
        },
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
    };
}

function mapStateToProps(state: State, _ownProps) {
    const canImport = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementPark);
    const canAuthorizeTask = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementVerify);
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);
    const beneficiaryPrimaryIdentifierType = state.appConfig.beneficiaryPrimaryIdentifierType;

    return {
        canPark: canImport && state?.auth?.manager?.agency !== 'ALL',
        canPost: canAuthorizeTask,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.UPLOAD_TAX_ID_FAMILY_TAX_ID_MAPPING],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BB HoH-HM Mapping Template.xlsx',
        name: `Upload HoH to HM ${BeneficiaryPrimaryIdentifierToShow[beneficiaryPrimaryIdentifierType]} Mapping.`,
        type: AsyncTasksTypes.UPLOAD_TAX_ID_FAMILY_TAX_ID_MAPPING,
        uploadDescription: `Upload HoH to HM ${BeneficiaryPrimaryIdentifierToShow[beneficiaryPrimaryIdentifierType]} mapping XLSX.GPG file by clicking the button below.`,
        exampleLinkTitle: 'See example import file',
        listView: AsyncTasksListView,
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
        mapping: {
            familyTaxId: 1,
            taxId: 2,
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage);
